export default __webpack_public_path__ + "static/logo-image-5ed9fc31c0aac213b969dd2a1e2b9645.gif";